import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import Slider from 'react-slick'
import texts from '../../../common/texts.json'
import { iscategoryActive, sliderCategoriesResponsiveConfig } from './utils'

const CategorySlider = ({
  categories, configData, products, isMobile,
}) => (
  <section className="void-plp__suggested-category">
    <h2>
      {products.length === 0
        ? texts.VOID_PLP.CATEGORY_TEXT
        : texts.VOID_PLP.ALT_CATEGORY_TEXT}
    </h2>
    <div className="void-plp__suggested-category__list">
      <Slider
        autoplay
        autoplaySpeed={4000}
        infinite
        dots
        pauseOnHover
        speed={500}
        slidesToShow={7}
        slidesToScroll={4}
        arrows={!isMobile}
        lazyLoad
        responsive={sliderCategoriesResponsiveConfig}
      >
        {categories.map((category, i) => (
          <Link key={i} to={category.link}>
            <article className={`void-plp__suggested-category__item ${iscategoryActive(category)}`}>
              <div>
                <div>
                  <img
                    height="26px"
                    width="26px"
                    alt={`category-${category.name}`}
                    src={`${configData.storageBaseUrl}${category.image}`}
                  />
                  <span>{category.name}</span>
                </div>
              </div>
            </article>
          </Link>
        ))}
      </Slider>
    </div>
  </section>
)

CategorySlider.defaultProps = {
  products: [],
  categories: [],
  configData: {},
}
CategorySlider.propTypes = {
  products: PropTypes.array,
  categories: PropTypes.array,
  configData: PropTypes.any,
  isMobile: PropTypes.bool.isRequired,
}

export default CategorySlider
